import _extends from "@babel/runtime/helpers/extends";
import { jsx as ___EmotionJSX } from "@emotion/core";
import React from 'react';

var _ref =
/*#__PURE__*/
___EmotionJSX("circle", {
  cx: 24,
  cy: 28,
  r: 24,
  fill: "#C1E5FF"
});

var _ref2 =
/*#__PURE__*/
___EmotionJSX("circle", {
  cx: 24,
  cy: 24,
  r: 24,
  fill: "#73C4FF"
});

var _ref3 =
/*#__PURE__*/
___EmotionJSX("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.64 32.352l37.766-21.805a21.977 21.977 0 0 1 2.992 5.2L6.655 37.538a21.98 21.98 0 0 1-3.016-5.186z",
  fill: "#95D3FF"
});

var SvgComponent = function SvgComponent(props) {
  return ___EmotionJSX("svg", _extends({
    width: 48,
    height: 52,
    fill: "none"
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/faq-aspirin.b50cc573.svg";
export { SvgComponent as ReactComponent };